// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-n"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.5 19L7.5 5L15.5 5C16.0523 5 16.5 5.44772 16.5 6L16.5 19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersNIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-n',
    ref,
    icon: element,
  },
));

LettersNIcon.displayName = 'LettersNIcon';

export default LettersNIcon;
